// extracted by mini-css-extract-plugin
export default {"bookList":"books_bookList__3PqUH","card":"books_card__Z+eth","cards":"books_cards__YysXM","pageContent":"books_pageContent__v5Hnh"};